import { useState, useEffect } from "react";
import UtilHelper from "../utils/UtilHelper";

type Props = {
  httpExpensebycategoryFn?: any;
  httpCashflowFn?: any;
  customMonthField?: string;
  parentEntityId: number;
  fullyQualifiedFilters: any; // REMOVED
  dateFilterDateFilterTypeId?: number; // ADDED
  dateFilterClientDate?: string;       // ADDED
};

export const useAnalyticsHook = ({
  httpExpensebycategoryFn,
  httpCashflowFn,
  customMonthField,
  parentEntityId,
  fullyQualifiedFilters,
  dateFilterDateFilterTypeId, // Destructure new prop
  dateFilterClientDate,       // Destructure new prop
}: Props) => {
  const [cashFlow, setCashFlow] = useState([]);
  const [expensebycategoryArr, setExpensebycategoryArr] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAndFormatExpensebycategory = () => {
    if (typeof httpExpensebycategoryFn === "function" && parentEntityId) {
      setLoading(true);
      httpExpensebycategoryFn(
        parentEntityId,
        undefined, // pageSize
        undefined, // pageNumber
        undefined, // skipValue
        undefined, // filterEntityTypeId
        undefined, // filterEntityIds
        undefined, // fullyQualifiedFilters (Now undefined)
        fullyQualifiedFilters?.fin, // fullyQualifiedSorts
        dateFilterDateFilterTypeId, // Argument 9
        dateFilterClientDate        // Argument 10
      )
        .then((response: any) => {
          if (response?.success?.length > 0) {
            let formatedExpCatArr: any[] = [];
            for (const expCat of response.success) {
              const expenseType = expCat.expenseType;
              const expenseName = expCat.formatted?.ExpenseType;
              const expenseAmount = Number(expCat.amount);

              let foundIndex = formatedExpCatArr.findIndex(
                (t) => t.name === expenseName
              );

              if (foundIndex > -1) {
                formatedExpCatArr[foundIndex].value += expenseAmount;
              } else {
                const assignedColor = UtilHelper.ExpenseTypeColors(expenseType);

                formatedExpCatArr.push({
                  name: expenseName,
                  value: expenseAmount,
                  color: assignedColor,
                });
              }
            }

            setExpensebycategoryArr(formatedExpCatArr);
          } else {
            setExpensebycategoryArr([]);
          }
          setLoading(false);
        })
        .catch((error: any) => {
          console.error("Fetch error:", error);
          setLoading(false);
        });
    }
  };

  const fetchAndFormatCashflow = () => {
    if (typeof httpCashflowFn === "function" && parentEntityId) {
      setLoading(true);

      httpCashflowFn(
        parentEntityId,
        undefined, // pageSize
        undefined, // pageNumber
        undefined, // skipValue
        undefined, // filterEntityTypeId
        undefined, // filterEntityIds
        fullyQualifiedFilters?.rev, // fullyQualifiedFilters (Now undefined)
        undefined, // fullyQualifiedSorts
        dateFilterDateFilterTypeId, // Argument 9
        dateFilterClientDate        // Argument 10
      )
        .then((response: any) => {
          const upd = response?.success?.map(
            (c: { expense: any; income: number; month: any; year: any }) => ({
              expense: c?.expense,
              income: c?.income + 500,
              [customMonthField || "month"]: `${c?.month}/${c?.year}`,
            })
          );

          setCashFlow(upd);
          setLoading(false);
        })
        .catch((error: any) => {
          console.error("Fetch error:", error);
          setLoading(false);
        });
    }
  };

  // Update dependency array to watch the new Enum ID
  useEffect(() => {
    fetchAndFormatCashflow();
  }, [dateFilterDateFilterTypeId, parentEntityId, fullyQualifiedFilters?.rev]);

  // Update dependency array to watch the new Enum ID
  useEffect(() => {
    fetchAndFormatExpensebycategory();
  }, [dateFilterDateFilterTypeId, parentEntityId, fullyQualifiedFilters?.fin]);

  return {
    loading,
    cashFlow,
    expensebycategoryArr,
    fetchAndFormatExpensebycategory,
  };
};